import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, AlertTriangle, CalendarClock, Flame, UserPlus, Briefcase, MessageSquare } from "lucide-react";
import api from "../lib/apiClient";

const ICON = { task_overdue: AlertTriangle, task_today: CalendarClock, project_risk: Flame, manager_invite: UserPlus, proposal_received: Briefcase, proposal_accepted: Briefcase, message_received: MessageSquare };

export function NotificationBell() {
  const [data, setData] = useState({ count: 0, notifications: [] });
  const [open, setOpen] = useState(false);
  const [seenSig, setSeenSig] = useState(() => localStorage.getItem("notifSeenSig") || "");
  const ref = useRef(null);
  const navigate = useNavigate();

  const sigOf = (list) => (list || []).map((n) => `${n.type}:${n.task_id || n.token || n.request_id || n.conversation_id || n.project_id || n.title}`).join("|");
  const sig = sigOf(data.notifications);
  const unread = data.count > 0 && sig !== seenSig;
  const markSeen = () => { setSeenSig(sig); try { localStorage.setItem("notifSeenSig", sig); } catch {} };

  const load = async () => {
    try { setData((await api.get("/notifications")).data); } catch {}
  };
  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => { clearInterval(id); document.removeEventListener("mousedown", onDoc); };
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((v) => { const nv = !v; if (nv) markSeen(); return nv; })} data-testid="notif-bell"
        className="relative w-10 h-10 rounded-xl border border-zinc-800 text-zinc-400 hover:text-amber-400 hover:border-amber-500/40 flex items-center justify-center">
        <Bell className="w-5 h-5" />
        {unread && (
          <span data-testid="notif-count" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-black text-[10px] font-bold flex items-center justify-center">{data.count}</span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-[#18181E] border border-zinc-800 rounded-2xl shadow-2xl z-50 p-2" data-testid="notif-panel">
          {data.notifications.length === 0 ? (
            <p className="text-sm text-zinc-500 p-4 text-center">Aucune notification. Tu gères ! 💪</p>
          ) : data.notifications.map((n, i) => {
            const Icon = ICON[n.type] || Bell;
            return (
              <button key={i} data-testid={`notif-item-${i}`}
                onClick={() => { setOpen(false); navigate(n.type === "manager_invite" ? `/invite/${n.token}` : n.type === "proposal_received" ? `/marketplace/requests/${n.request_id}` : (n.type === "message_received" || n.type === "proposal_accepted") ? `/messages/${n.conversation_id || ""}` : n.type === "project_risk" ? "/projects" : "/tasks"); }}
                className="w-full text-left flex items-start gap-3 p-3 rounded-xl hover:bg-zinc-800/60">
                <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${n.type === "task_overdue" ? "text-red-400" : n.type === "project_risk" ? "text-orange-400" : n.type === "manager_invite" ? "text-emerald-400" : "text-amber-400"}`} />
                <span className="text-sm text-zinc-300">{n.title}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
